export default {
  name: "SheepTileComponent",
  props: {
    tile: {
      type: Object,
      required: true
    },
    inSlot: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    // 基础样式
    baseStyle() {
      return "tile";
    },
    // 可点击状态样式
    clickableStyle() {
      return "";
    },
    // 禁用状态样式
    disabledStyle() {
      return "opacity-50 disabled";
    },
    // 位置样式
    positionStyle() {
      if (this.inSlot) {
        return {};
      } else {
        return {
          position: "absolute",
          left: `calc(50% + ${this.tile.x * 42}px - 24px)`,
          top: `calc(50% + ${this.tile.y * 48}px - 28px)`,
          zIndex: this.tile.zIndex
        };
      }
    }
  },
  methods: {
    handleClick() {
      if (this.tile.isClickable || this.inSlot) {
        this.$emit("click", this.tile);
      }
    }
  }
};